import bgPortfolioSrc from '@assets/images/bg-portfolio.jpg';

import { DefaultWidgetNames, WidgetType } from '@/api/rest/resources/types/widget';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useWidgetSlotConfigurationByNameType } from '@/hooks/useWidgetConfigurationByOrganizationId';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { SignedInPageLayoutContentContainer } from '@/layout/signed-in-page/components';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';

import { About, Help, Hero } from './components';

export const LandstewardPortfolioPage = () => {
  const menuItems = useMenuItems();
  const widgetSlotsConfiguration = useWidgetSlotConfigurationByNameType(
    DefaultWidgetNames.default_template_contracts,
    WidgetType.t_page,
  );

  return (
    <SignedInPageLayout items={menuItems} withCustomContentContainer>
      <div className='bg-cover full-bleed-x' style={{ backgroundImage: `url(${bgPortfolioSrc})` }}>
        <SignedInPageLayoutContentContainer>
          <Hero />
        </SignedInPageLayoutContentContainer>
      </div>
      <SignedInPageLayoutContentContainer>
        <WidgetSlotRenderer nestedWidget={widgetSlotsConfiguration} />
        <div className='flex flex-col gap-8 lg:flex-row'>
          <About className='lg:w-1/2' />
          <Help className='lg:w-1/2' />
        </div>
      </SignedInPageLayoutContentContainer>
    </SignedInPageLayout>
  );
};
